/**
 * Handle focus management when page loads with a hash anchor
 * This ensures screenreaders are moved to the target location after navigation
 *
 * For accessibility, target elements should have tabindex="-1" to be focusable
 *
 */
export function handleHashFocus() {
  if (window.location.hash) {
    const hash = window.location.hash.substring(1);
    if (hash) {
      const $target = document.getElementById(hash);
      if ($target) {
        // Skip empty elements (like empty anchor links used as jumplinks)
        const hasContent =
          $target.textContent.trim().length > 0 || $target.children.length > 0;

        if (hasContent) {
          // Small delay to ensure page has scrolled and content is rendered
          setTimeout(() => {
            $target.setAttribute('tabindex', '-1'); // Ensure focusable
            $target.focus();
          }, 100);
        }
      }
    }
  }
}

/**
 * Initialize hash focus handling on page load
 * Automatically called when module is imported
 */
export function initHashFocus() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleHashFocus);
  } else {
    handleHashFocus();
  }
}

// Auto-initialize when imported
initHashFocus();

export default initHashFocus;
